import { TRouterLink } from "@/models/router";
import { RouteConfig } from "vue-router";
import PLayout from "./PLayout.vue";
import { RCandidate } from "./views/Candidate/RCandidate";
import { REmployee } from "./views/Employee/REmployee";
import { REmployer } from "./views/Employer/REmployer";
import { RExpert } from "./views/Expert/RExpert";

export const RLayout: RouteConfig = {
  path: "/",
  component: PLayout,
  children: [RCandidate, REmployer, REmployee, RExpert],
  meta: {
    auth: true,
  },
};

export const routeLinks: TRouterLink[] = [];
